import React, { Fragment, useState, useContext, useEffect } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AddFollowUp } from 'components/sales/formSection/addFollowUp/addFollowUp';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PocForm from 'components/sales/formSection/pocForm/pocForm';

const CreateFollowUp = ({
  match,
  getFollowUpDropDown,
  followUpDropDown,
  saveFollowUp,
  followUpSuccess,
  documentUploadUrl,
  documentUrlData,
  history,
  addPoc,
  pocById,
}) => {
  const pocInputs = {
    pocDetails: null,
  };
  const [ListGate, setlistGate] = useState();
  const [formData, setformData] = useState();
  const [isFiled, setIsFiled] = useState(false);
  const [isPocFiled, setIsPocFiled] = useState(false);
  const [allFilled, setAllFilled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isPocModal, setIsPocModal] = useState(false);
  const [isPocSuccessModal, setIsPocSuccessModal] = useState(false);
  const [leadId, setleadId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [pocData, setCorporateData] = useState(pocInputs);

  useEffect(() => {
    setleadId(match.params.id);
  }, []);

  const handlePocSubmit = (val) => {
    setCorporateData({ ...pocData, pocDetails: val });
  };

  useEffect(() => {
    if (
      followUpSuccess &&
      followUpSuccess.status &&
      formData &&
      formData.val !== null
    ) {
      setIsModal(true);
    }
  }, [followUpSuccess]);

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/followUp/${leadId}`);
  };

  useEffect(() => {
    if (getFollowUpDropDown !== null && leadId)
      (async () => await getFollowUpDropDown(leadId))();
  }, [getFollowUpDropDown, leadId]);

  useEffect(() => {
    setlistGate(followUpDropDown);
  }, [followUpDropDown]);

  const handleSubmit = () => {
    if (formData.val === null) {
      setIsFiled(true);
      setAllFilled(false);
      return false;
    } else {
      setIsFiled(false);
      setAllFilled(true);
    }
  };

  const handleSubmitPoc = async () => {
    const { pocDetails } = pocData;
    if (pocDetails === null) {
      setIsPocFiled(true);
      setIsPocSuccessModal(false);
      return false;
    } else {
      setIsPocFiled(false);
      const res = await addPoc(pocDetails);
      if (res.status === 1) {
        setIsPocModal(false);
        setIsPocSuccessModal(true);
        await getFollowUpDropDown(leadId);
      }
    }
  };

  const handleForm = (val) => {
    setformData({ val });
  };

  useEffect(() => {
    if (allFilled === true) {
      (async () => await saveFollowUp(formData.val))();
    }
  }, [allFilled]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={() => {
            setIsPocModal(true);
          }}
          className="btn btn-primary d-none d-md-inline-block"
        >
          {localization.addPOCButton}
        </Button>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.followUpListing}
      className={isFiled ? 'requiredFileds' : ''}
      Buttons={headerBtns}
      isGoback
    >
      <AddFollowUp
        data={ListGate}
        handleValue={handleForm}
        match={match}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.followUpSuccess}</h5>
          <Link
            to={`${baseUrl}/followUp/${match.params.id}`}
            className="btn btn-primary mb-4"
          >
            {localization.followUpSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.pocDetailTitle}
        show={isPocModal}
        handleModalHide={() => {
          setIsPocModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <PocForm
            pocById={pocById}
            handleValue={handlePocSubmit}
            className={isPocModal ? 'requiredFileds' : ''}
            noTitle={true}
            leadId={leadId}
          />
          <Button onClick={handleSubmitPoc} className="btn btn-primary">
            {localization.submitDtl}
            <img src={Images?.arrowRightBlue} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={isPocSuccessModal}
        handleModalHide={() => {
          setIsPocSuccessModal(false);
        }}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.pocSucces}</h5>
        </div>
        <Button
          onClick={() => {
            setIsPocSuccessModal(false);
          }}
          className="btn btn-primary"
        >
          {localization.continue}
          <img src={Images?.arrowRightBlue} alt="" />
        </Button>
      </ModalPop>
    </Layout>
  );
};

CreateFollowUp.propTypes = {};

export default CreateFollowUp;
